import { render } from "./EmptyStateGeneric.vue?vue&type=template&id=6208206a&scoped=true"
import script from "./EmptyStateGeneric.vue?vue&type=script&lang=js"
export * from "./EmptyStateGeneric.vue?vue&type=script&lang=js"

import "./EmptyStateGeneric.vue?vue&type=style&index=0&id=6208206a&lang=scss&scoped=true"

import exportComponent from "/app/tmp/downer/V3/v2025.50.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6208206a"]])

export default __exports__